import { useSyncExternalStore } from 'react';

import { MOBILE_BREAKPOINT_PX } from '@/shared/components/layout/_constants';

function subscribe(maxWidth: number, callback: () => void) {
  const mql = window.matchMedia(`(max-width: ${maxWidth}px)`);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

function getSnapshot(maxWidth: number) {
  return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
}

/** 뷰포트 폭이 maxWidth(기본: 모바일 브레이크포인트) 이하인지, 리사이즈에 실시간으로 반응해서 알려준다. */
export function useIsMobileViewport(maxWidth = MOBILE_BREAKPOINT_PX) {
  return useSyncExternalStore(
    (callback) => subscribe(maxWidth, callback),
    () => getSnapshot(maxWidth)
  );
}
